<template>
  <v-card class="ma-3 pa-3">
    <!-- Modal to bulk edit -->
    <v-layout row justify-center>
      <v-dialog v-model="showBulkEditForm" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('Edición múltiple: ') + bulk.fieldText }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 class="text-xs-center">
                  <h3>Se aplicará a todos los elementos seleccionados</h3>
                  <h3 class="text-red" v-if="bulk.fieldValue === 'active'">
                    Si no selecciona ninguna opción se marcarán por defecto como BAJA
                  </h3>
                  <h3
                    class="text-red"
                    v-if="
                      bulk.fieldValue === 'has_111_employees' ||
                        bulk.fieldValue === 'has_111_professionals'
                    "
                  >
                    Si no selecciona ninguna opción se marcarán por defecto como NO
                  </h3>
                  <h3
                    class="text-red"
                    v-if="
                      bulk.fieldValue === 'consultant' || bulk.fieldValue === 'labor_consultant'
                    "
                  >
                    Si no selecciona ninguna opción se eliminarán las asignaciones actuales
                  </h3>
                </v-flex>
                <v-layout wrap class="mt-4">
                  <v-flex xs12>
                    <div class="ml-3">
                      <v-select
                        v-if="bulk.fieldValue && bulk.fieldValue.includes('mod_')"
                        color="primary"
                        v-model="bulk.modelStatus"
                        item-text="text"
                        item-value="value"
                        :items="modelOptions"
                        row
                        :label="$t('Estado del modelo')"
                      ></v-select>
                      <v-select
                        v-else-if="bulk.fieldValue && bulk.fieldValue.includes('labor_consultant')"
                        color="primary"
                        v-model="bulk.laborConsultant"
                        item-text="text"
                        item-value="value"
                        :items="consultantsList"
                        row
                        :label="$t('Asesor/a Laboral')"
                      ></v-select>
                      <v-select
                        v-else-if="bulk.fieldValue && bulk.fieldValue.includes('consultant')"
                        color="primary"
                        v-model="bulk.consultant"
                        item-text="text"
                        item-value="value"
                        :items="consultantsList"
                        row
                        :label="$t('Asesor/a Fiscal')"
                      ></v-select>
                      <v-select
                        v-else-if="bulk.fieldValue && bulk.fieldValue.includes('active')"
                        color="primary"
                        v-model="bulk.active"
                        item-text="text"
                        item-value="value"
                        :items="[{ text: 'ACTIVO', value: true }, { text: 'BAJA', value: false }]"
                        row
                        :label="$t('Estado Empresa')"
                      ></v-select>
                      <v-select
                        v-else-if="bulk.fieldValue && bulk.fieldValue.includes('status')"
                        color="primary"
                        v-model="bulk.status"
                        item-text="text"
                        item-value="value"
                        :items="fiscalStatusOptions.filter(item => item.value !== 'SIN_DATOS')"
                        row
                        :label="$t('Estado Fiscal')"
                      ></v-select>
                      <v-select
                        v-else-if="bulk.fieldValue && bulk.fieldValue.includes('has_111_employees')"
                        color="primary"
                        v-model="bulk.hasEmployees"
                        item-text="text"
                        item-value="value"
                        :items="[{ text: 'SÍ', value: true }, { text: 'NO', value: false }]"
                        row
                        :label="$t('¿Empleados?')"
                      ></v-select>
                      <v-select
                        v-else-if="
                          bulk.fieldValue && bulk.fieldValue.includes('has_111_professionals')
                        "
                        color="primary"
                        v-model="bulk.hasProfessionals"
                        item-text="text"
                        item-value="value"
                        :items="[{ text: 'SÍ', value: true }, { text: 'NO', value: false }]"
                        row
                        :label="$t('¿Profesionales?')"
                      ></v-select>
                      <v-text-field
                        v-else
                        v-model="bulk.text"
                        :label="$t(`${this.bulk.fieldText}`)"
                      ></v-text-field>
                    </div>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-container>
            <v-container v-if="bulkSavingFiscalObligations">
              <v-flex xs12>
                <div class="text-xs-center">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </div>
              </v-flex>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              flat
              @click="showBulkEditForm = false"
              :disabled="bulkSavingFiscalObligations"
            >
              {{ $t('Cerrar') }}
            </v-btn>
            <v-btn
              color="primary"
              @click="saveBulkEditForm()"
              :disabled="bulkSavingFiscalObligations"
            >
              {{ $t('Guardar') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- End modal -->

    <!-- Data table with fiscal obligations -->
    <v-data-table
      ref="fiscalObligations111and190Table"
      v-model="selectedItems"
      :loading="loading"
      :headers="headers"
      :items="fiscalObligations"
      :pagination.sync="fObligationsPagination"
      :rows-per-page-items="[10, 20, 30, 50, 100]"
      :total-items="fObligationsPagination.totalItems"
      select-all
    >
      <template v-slot:no-data>
        <v-alert :value="true" color="info" icon="info" outline>
          {{ $t('No hay información que mostrar con los filtros seleccionados :(') }}
        </v-alert>
      </template>
      <template v-slot:headers="props">
        <tr>
          <th v-if="props.headers.length > 0">
            <v-checkbox
              v-model="selectAllRows"
              @change="selectAllTableRows()"
              primary
              hide-details
            ></v-checkbox>
          </th>
          <template v-for="header in props.headers">
            <th
              :key="`th_${header.value}`"
              :class="[
                'text-xs-center',
                header.sortable ? 'column sortable' : '',
                fObligationsPagination.descending ? 'desc' : 'asc',
                header.value === fObligationsPagination.sortBy ? 'active' : '',
              ]"
              @click="
                header.sortable
                  ? changeSort(header.value)
                  : openBulkEditForm(header.text, header.value)
              "
            >
              <v-icon v-if="header.sortable" small>arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </template>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr :style="!props.item.active ? 'background-color: pink' : ''">
          <td>
            <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
          </td>
          <td class="text-xs-center">
            {{ props.item.clavedat }}
          </td>
          <td class="text-xs-center">
            {{ props.item.name }}
          </td>
          <td class="text-xs-center">
            {{ props.item.cif }}
          </td>
          <td class="text-xs-center">
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.consultant }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.consultant_id"
              large
              lazy
              persistent
              @save="
                saveQuartersRowField(
                  props.item,
                  props.item.clavedat,
                  'consultant_id',
                  props.item.consultant_id,
                  year,
                  null,
                )
              "
              @cancel="cancelSaveRow(props.item)"
            >
              <div>{{ props.item.consultant }}</div>
              <template v-slot:input>
                <div class="mt-3">Asesor/a Fiscal</div>
                <v-select
                  color="primary"
                  v-model="props.item.consultant_id"
                  item-text="text"
                  item-value="value"
                  :items="consultantsList"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td class="text-xs-center">
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.labor_consultant }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.labor_consultant_id"
              large
              lazy
              persistent
              @save="
                saveQuartersRowField(
                  props.item,
                  props.item.clavedat,
                  'labor_consultant_id',
                  props.item.labor_consultant_id,
                  year,
                  null,
                )
              "
              @cancel="cancelSaveRow(props.item)"
            >
              <div>{{ props.item.labor_consultant }}</div>
              <template v-slot:input>
                <div class="mt-3">Asesor/a Laboral</div>
                <v-select
                  color="primary"
                  v-model="props.item.labor_consultant_id"
                  item-text="text"
                  item-value="value"
                  :items="consultantsList"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td class="text-xs-center">
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.active_text }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.active"
              large
              lazy
              persistent
              @save="
                saveRowField(
                  props.item,
                  props.item.clavedat,
                  'active',
                  props.item.active,
                  year,
                  null,
                )
              "
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.active_text }}</div>
              <template v-slot:input>
                <div class="mt-3">Estado Empresa</div>
                <v-select
                  color="primary"
                  v-model="props.item.active"
                  item-text="text"
                  item-value="value"
                  :items="[{ text: 'ACTIVO', value: true }, { text: 'BAJA', value: false }]"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            :bgcolor="props.item.has_111_employees ? 'lightgreen' : 'lightgray'"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.has_111_employees ? 'SÍ' : 'NO' }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.has_111_employees"
              large
              lazy
              persistent
              @save="
                saveQuartersRowField(
                  props.item,
                  props.item.clavedat,
                  'has_111_employees',
                  props.item.has_111_employees,
                  year,
                  null,
                )
              "
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.has_employees }}</div>
              <template v-slot:input>
                <div class="mt-3">¿Empleados?</div>
                <v-select
                  color="primary"
                  v-model="props.item.has_111_employees"
                  item-text="text"
                  item-value="value"
                  :items="[{ text: 'SÍ', value: true }, { text: 'NO', value: false }]"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            :bgcolor="props.item.has_111_professionals ? 'lightgreen' : 'lightgray'"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.has_111_professionals ? 'SÍ' : 'NO' }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.has_111_professionals"
              large
              lazy
              persistent
              @save="
                saveQuartersRowField(
                  props.item,
                  props.item.clavedat,
                  'has_111_professionals',
                  props.item.has_111_professionals,
                  year,
                  null,
                )
              "
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.has_professionals }}</div>
              <template v-slot:input>
                <div class="mt-3">¿Profesionales?</div>
                <v-select
                  color="primary"
                  v-model="props.item.has_111_professionals"
                  item-text="text"
                  item-value="value"
                  :items="[{ text: 'SÍ', value: true }, { text: 'NO', value: false }]"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td class="text-xs-center">
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.observations }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.observations"
              large
              lazy
              persistent
              @save="
                saveRowField(
                  props.item,
                  props.item.clavedat,
                  'observations',
                  props.item.observations,
                  year,
                  null,
                )
              "
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.observations }}</div>
              <template v-slot:input>
                <div class="mt-3">Observaciones</div>
                <v-text-field
                  v-model="props.item.observations"
                  single-line
                  autofocus
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            :bgcolor="getBgColorForModelEntries(props.item.mod_111_t1, props.item.has_t1)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_111_t1 }}
            </div>
            <v-edit-dialog
              v-else-if="props.item.has_t1"
              :return-value.sync="props.item.mod_111_t1"
              large
              lazy
              persistent
              @save="
                saveRowField(
                  props.item,
                  props.item.clavedat,
                  'mod_111',
                  props.item.mod_111_t1,
                  year,
                  '1',
                )
              "
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_111_t1 }}</div>
              <template v-slot:input>
                <div class="mt-3">T1 - Modelo 111</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_111_t1"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            :bgcolor="getBgColorForModelEntries(props.item.mod_111_t2, props.item.has_t2)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_111_t2 }}
            </div>
            <v-edit-dialog
              v-else-if="props.item.has_t2"
              :return-value.sync="props.item.mod_111_t2"
              large
              lazy
              persistent
              @save="
                saveRowField(
                  props.item,
                  props.item.clavedat,
                  'mod_111',
                  props.item.mod_111_t2,
                  year,
                  '2',
                )
              "
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_111_t2 }}</div>
              <template v-slot:input>
                <div class="mt-3">T2 - Modelo 111</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_111_t2"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            :bgcolor="getBgColorForModelEntries(props.item.mod_111_t3, props.item.has_t3)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_111_t3 }}
            </div>
            <v-edit-dialog
              v-else-if="props.item.has_t3"
              :return-value.sync="props.item.mod_111_t3"
              large
              lazy
              persistent
              @save="
                saveRowField(
                  props.item,
                  props.item.clavedat,
                  'mod_111',
                  props.item.mod_111_t3,
                  year,
                  '3',
                )
              "
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_111_t3 }}</div>
              <template v-slot:input>
                <div class="mt-3">T3 - Modelo 111</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_111_t3"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            :bgcolor="getBgColorForModelEntries(props.item.mod_111_t4, props.item.has_t4)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_111_t4 }}
            </div>
            <v-edit-dialog
              v-else-if="props.item.has_t4"
              :return-value.sync="props.item.mod_111_t4"
              large
              lazy
              persistent
              @save="
                saveRowField(
                  props.item,
                  props.item.clavedat,
                  'mod_111',
                  props.item.mod_111_t4,
                  year,
                  '4',
                )
              "
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_111_t4 }}</div>
              <template v-slot:input>
                <div class="mt-3">T4 - Modelo 111</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_111_t4"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            :bgcolor="getBgColorForModelEntries(props.item.mod_190_t4, props.item.has_t4)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_190_t4 }}
            </div>
            <v-edit-dialog
              v-else-if="props.item.has_t4"
              :return-value.sync="props.item.mod_190_t4"
              large
              lazy
              persistent
              @save="
                saveRowField(
                  props.item,
                  props.item.clavedat,
                  'mod_190',
                  props.item.mod_190_t4,
                  year,
                  '4',
                )
              "
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_190_t4 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 190</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_190_t4"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
    </v-snackbar>
  </v-card>
</template>

<script>
import apiCtrl from '@/services/api/abstract/abstract-api.js';

export default {
  name: 'ManageFiscalObligationsTable',
  components: {},
  props: [
    'year',
    'search',
    'consultant_ids',
    'labor_consultant_ids',
    'selected_model_type',
    'selected_model_status',
    'has_employees',
    'has_professionals',
    'show_manage_model_111',
    'consultantsList',
    'isBeingReviewed',
    'canReviewFiscalObligations',
  ],
  data() {
    return {
      selectedItems: [],
      selectAllRows: false,
      loading: false,
      exportingExcel: false,
      bulkSavingFiscalObligations: false,
      showBulkEditForm: false,
      headers: [],
      fiscalObligations: [],
      exportFiscalObligationsList: [],
      modelOptions: [
        { text: 'SIN OBLIGACIÓN', value: null },
        { text: 'PENDIENTE', value: 'PENDIENTE' },
        { text: 'DOMICILIAR?', value: 'DOMICILIAR?' },
        { text: 'NRC?', value: 'NRC?' },
        { text: 'DOMICILIAR', value: 'DOMICILIAR' },
        { text: 'NRC', value: 'NRC' },
        { text: 'APLAZAR', value: 'APLAZAR' },
        { text: 'COMPENSAR', value: 'COMPENSAR' },
        { text: 'NEGATIVO', value: 'NEGATIVO' },
        { text: 'PRESENTAR', value: 'PRESENTAR' },
        { text: 'NO TIENE', value: 'NO TIENE' },
        { text: 'PRESENTADO', value: 'PRESENTADO' },
        { text: 'PRESENTADO APLAZADO', value: 'PRESENTADO APLAZADO' },
        { text: 'A DEVOLVER', value: 'A DEVOLVER' },
        { text: 'EN BLANCO', value: 'EN BLANCO' },
      ],
      snack: false,
      snackText: '',
      snackColor: 'info',
      fObligationsPagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10, // -1 for All",
        sortBy: '',
        totalItems: 0,
      },
      sortTable: false,
      bulk: {
        fieldText: null,
        fieldValue: null,
        modelStatus: null,
        consultant: null,
        laborConsultant: null,
        text: null,
        active: null,
        status: null,
        hasEmployees: null,
        hasProfessionals: null,
      },
      fiscalStatusOptions: [
        { text: 'CONTABILIZADO', value: 'CONTABILIZADO' },
        { text: 'ENVIADO', value: 'ENVIADO' },
        { text: 'CERRADO', value: 'CERRADO' },
        { text: 'SIN DATOS', value: 'SIN_DATOS' },
      ],
    };
  },
  mounted() {
    this.getFiscalObligationList();
  },
  computed: {
    currentPage() {
      return this.fObligationsPagination.page;
    },
    perPage() {
      return this.fObligationsPagination.rowsPerPage;
    },
    sortBy() {
      return this.fObligationsPagination.sortBy;
    },
    descending() {
      return this.fObligationsPagination.descending;
    },
    selectedYear() {
      return this.year;
    },
    selectedConsultants() {
      return this.consultant_ids;
    },
    selectedLaborConsultants() {
      return this.labor_consultant_ids;
    },
    selectedModelStatus() {
      return this.selected_model_status;
    },
    selectedModelType() {
      return this.selected_model_type;
    },
    hasEmployees() {
      return this.has_employees;
    },
    hasProfessionals() {
      return this.has_professionals;
    },
  },
  methods: {
    selectAllTableRows() {
      if (
        this.selectedItems.length === 0 ||
        (this.selectedItems.length >= 1 &&
          this.selectedItems.length < this.fiscalObligations.length)
      ) {
        let selected = [];
        this.fiscalObligations.forEach(item => {
          selected.push(item);
        });
        this.selectedItems = selected;
      } else if (this.selectedItems.length === this.fiscalObligations.length) {
        this.selectedItems = [];
      }
    },
    showSnackMessage(action, message) {
      this.snackColor = action;
      this.snackText = message;
      this.snack = true;
    },
    updateConsultantRow(item) {
      let consultant = this.consultantsList.find(
        consultant => consultant.value === item.consultant_id,
      );
      if (consultant) {
        item.consultant = consultant.text;
      }
    },
    updateLaborConsultantRow(item) {
      let consultant = this.consultantsList.find(
        consultant => consultant.value === item.labor_consultant_id,
      );
      if (consultant) {
        item.labor_consultant = consultant.text;
      }
    },
    updateStatusRow(item) {
      item.active ? (item.active_text = 'ACTIVO') : (item.active_text = 'BAJA');
    },
    updateEmployeesProfessionalsRow(item) {
      item.has_111_employees ? (item.has_employees = 'SÍ') : (item.has_employees = 'NO');
      item.has_111_professionals
        ? (item.has_professionals = 'SÍ')
        : (item.has_professionals = 'NO');
    },
    getFiscalObligationList() {
      if (this.show_manage_model_111) {
        this.loading = true;
        const config = {
          params: {
            year: this.year,
            page: this.fObligationsPagination.page,
            per_page: this.fObligationsPagination.rowsPerPage,
            sort_by: this.fObligationsPagination.sortBy,
            descending: this.fObligationsPagination.descending,
            consultant_ids: this.consultant_ids,
            labor_consultant_ids: this.labor_consultant_ids,
            selected_model_type: this.selected_model_type,
            selected_model_status: this.selected_model_status,
            has_employees: this.has_employees,
            has_professionals: this.has_professionals,
            search: this.search,
          },
        };
        apiCtrl
          .get('/admin/fiscal-obligations/manage-111-190-list', config)
          .then(res => {
            console.log(res.data);
            this.fiscalObligations = res.data.data;
            this.headers = res.data.dataTable.headers;
            this.fObligationsPagination = {
              descending: this.fObligationsPagination.descending,
              page: this.fObligationsPagination.page,
              rowsPerPage: Number(res.data.meta.per_page), // -1 for All",
              sortBy: this.fObligationsPagination.sortBy,
              totalItems: Number(res.data.meta.total),
            };
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
            // this.showSnackMessage(
            //   'error',
            //   'Se ha producido un error al cargar las obligaciones fiscales',
            // );
          });
      }
    },
    saveRowField(item, clavedat, field, value, year, quarter) {
      // Update manually the name of consultant of the updated row in case it had changed
      this.updateConsultantRow(item);
      this.updateLaborConsultantRow(item);

      // Update manually the name of status of the updated row in case it had changed
      this.updateStatusRow(item);

      // Update the model status of the selected quarter in backend
      if (quarter === null) {
        if (item.has_t4) {
          quarter = '4';
        } else if (item.has_t3) {
          quarter = '3';
        } else if (item.has_t2) {
          quarter = '2';
        } else if (item.has_t1) {
          quarter = '1';
        }
      }

      const data = {
        clavedat: clavedat,
        field: field,
        value: value,
        year: year,
        quarter: quarter,
      };
      apiCtrl
        .post('/admin/fiscal-obligations/update-field', data)
        .then(res => {
          console.log(res.data);
        })
        .catch(() => {
          // this.showSnackMessage('error', 'Se ha producido un error al actualizar');
          this.getFiscalObligationList();
        });
    },
    saveQuartersRowField(item, clavedat, field, value, year) {
      // Update manually the name of consultant of the updated row in case it had changed
      this.updateConsultantRow(item);
      this.updateLaborConsultantRow(item);
      this.updateEmployeesProfessionalsRow(item);
      // Update manually the name of status of the updated row in case it had changed
      this.updateStatusRow(item);

      const data = {
        clavedat: clavedat,
        field: field,
        value: value,
        year: year,
      };
      apiCtrl
        .post('/admin/fiscal-obligations/update-quarters-field', data)
        .then(res => {
          console.log(res.data);
        })
        .catch(() => {
          // this.showSnackMessage('error', 'Se ha producido un error al actualizar');
          this.getFiscalObligationList();
        });
    },
    cancelSaveRow() {},
    getBgColorForModelEntries(status, hasQuarter = true) {
      let color;
      if (hasQuarter) {
        switch (status) {
          case 'PENDIENTE':
            color = '#00afa8';
            break;
          case 'DOMICILIAR?':
            color = 'lemonchiffon';
            break;
          case 'NRC?':
            color = 'lemonchiffon';
            break;
          case 'DOMICILIAR':
            color = 'lightsalmon';
            break;
          case 'NRC':
            color = 'lightsalmon';
            break;
          case 'APLAZAR':
            color = 'lightsalmon';
            break;
          case 'COMPENSAR':
            color = 'lightblue';
            break;
          case 'NEGATIVO':
            color = 'lightblue';
            break;
          case 'PRESENTAR':
            color = 'lemonchiffon';
            break;
          case 'NO TIENE':
            color = 'lightgreen';
            break;
          case 'PRESENTADO':
            color = 'lightgreen';
            break;
          case 'PRESENTADO APLAZADO':
            color = 'lightpink';
            break;
          case 'A DEVOLVER':
            color = 'lightgreen';
            break;
          case 'EN BLANCO':
            color = 'white';
            break;
          default:
            color = 'lightgray';
        }
      } else {
        color = 'darkgray';
      }

      return color;
    },
    getFiscalObligationsIfStopChanges() {
      this.loading = true;
      const params = {
        page: this.fObligationsPagination.page,
        per_page: this.fObligationsPagination.rowsPerPage,
        search: this.search,
      };

      setTimeout(() => {
        if (
          params.page === this.fObligationsPagination.page &&
          params.per_page === this.fObligationsPagination.rowsPerPage &&
          params.search === this.search
        ) {
          this.getFiscalObligationList();
        }
      }, 300);
    },
    openBulkEditForm(text, value) {
      if (!this.isBeingReviewed || (this.isBeingReviewed && this.canReviewFiscalObligations)) {
        this.bulk.fieldValue = value;
        this.bulk.fieldText = text;

        this.bulk.consultant = null;
        this.bulk.laborConsultant = null;
        this.bulk.modelStatus = null;
        this.bulk.hasEmployees = null;
        this.bulk.hasProfessionals = null;
        this.bulk.text = null;
        this.bulk.active = null;
        this.bulk.status = null;

        if (value !== 'name' && value !== 'clavedat' && value !== 'cif') {
          this.showBulkEditForm = true;
        }
      }
    },
    saveBulkEditForm() {
      this.bulkSavingFiscalObligations = true;
      let items = this.selectedItems.map(item => {
        return item.id;
      });

      const bulkOptions = ['active', 'observations'];

      const bulkQuartersOptions = [
        'consultant',
        'labor_consultant',
        'has_111_employees',
        'has_111_professionals',
      ];

      if (bulkOptions.includes(this.bulk.fieldValue)) {
        apiCtrl
          .post('/admin/fiscal-obligations/bulk-edit', {
            selectedItems: items,
            field: this.bulk.fieldValue,
            consultant: this.bulk.consultant,
            laborConsultant: this.bulk.laborConsultant,
            text: this.bulk.text,
            active: this.bulk.active,
            has111Employees: this.bulk.hasEmployees,
            has111Professionals: this.bulk.hasProfessionals,
            status: this.bulk.status,
          })
          .then(res => {
            console.log(res);
            this.bulkSavingFiscalObligations = false;
            this.showBulkEditForm = false;
            this.selectedItems = [];
            this.selectAllRows = false;
            this.getFiscalObligationList();
          })
          .catch(() => {
            this.bulkSavingFiscalObligations = false;
            this.showBulkEditForm = false;
          });
      } else if (bulkQuartersOptions.includes(this.bulk.fieldValue)) {
        let selectedClavedat = this.selectedItems.map(item => {
          return item.clavedat;
        });
        apiCtrl
          .post('/admin/fiscal-obligations/bulk-quarters-edit', {
            year: this.selectedYear,
            selectedItems: selectedClavedat,
            field: this.bulk.fieldValue,
            consultant: this.bulk.consultant,
            laborConsultant: this.bulk.laborConsultant,
            text: this.bulk.text,
            has111Employees: this.bulk.hasEmployees,
            has111Professionals: this.bulk.hasProfessionals,
          })
          .then(res => {
            console.log(res);
            this.bulkSavingFiscalObligations = false;
            this.showBulkEditForm = false;
            this.selectedItems = [];
            this.selectAllRows = false;
            this.getFiscalObligationList();
          })
          .catch(() => {
            this.bulkSavingFiscalObligations = false;
            this.showBulkEditForm = false;
          });
      } else {
        let selectedClavedat = this.selectedItems.map(item => {
          return item.clavedat;
        });
        apiCtrl
          .post('/admin/fiscal-obligations/bulk-edit/model-status', {
            selectedItems: selectedClavedat,
            field: this.bulk.fieldValue,
            status: this.bulk.modelStatus,
            year: this.year,
          })
          .then(res => {
            console.log(res);
            this.bulkSavingFiscalObligations = false;
            this.showBulkEditForm = false;
            this.selectedItems = [];
            this.selectAllRows = false;
            this.getFiscalObligationList();
          })
          .catch(() => {
            this.bulkSavingFiscalObligations = false;
            this.showBulkEditForm = false;
          });
      }
    },
    async exportToExcel() {
      this.exportingExcel = true;
      import('../../../../plugins/Export2Excel.js').then(async excel => {
        const filterColumns = this.headers.map(header => header.value);
        const exportHeaders = this.headers
          .filter(header => filterColumns.includes(header.value))
          .map(header => header.text);
        const config = {
          params: {
            year: this.year,
            page: this.fObligationsPagination.page,
            per_page: this.fObligationsPagination.totalItems,
            sort_by: this.fObligationsPagination.sortBy,
            descending: this.fObligationsPagination.descending,
            consultant_ids: this.consultant_ids,
            labor_consultant_ids: this.labor_consultant_ids,
            selected_model_type: this.selected_model_type,
            selected_model_status: this.selected_model_status,
            has_employees: this.has_employees,
            has_professionals: this.has_professionals,
            search: this.search,
            exportToExcel: true,
          },
        };
        let fiscalObligationsListToExport = [];
        await apiCtrl
          .get('/admin/fiscal-obligations/manage-111-190-list', config)
          .then(res => {
            console.log(res.data);
            fiscalObligationsListToExport = res.data.data;
          })
          .catch(() => {
            this.showSnackMessage(
              'error',
              'Se ha producido un error al exportar las obligaciones fiscales',
            );
            this.exportingExcel = false;
          });
        const exportList = this.formatJson(filterColumns, fiscalObligationsListToExport);
        excel.export_json_to_excel({
          header: exportHeaders,
          data: exportList,
          filename: `obligaciones_fiscales_111_190_${this.year}}`,
          autoWidth: true,
          bookType: 'xlsx',
        });
        this.exportingExcel = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j];
        }),
      );
    },
    changeSort(column) {
      if (this.fObligationsPagination.sortBy === column) {
        this.fObligationsPagination.descending = !this.fObligationsPagination.descending;
      } else {
        this.fObligationsPagination.sortBy = column;
        this.fObligationsPagination.descending = false;
      }
    },
  },
  watch: {
    selectedYear: function() {
      if (this.currentPage === 1) {
        this.getFiscalObligationsIfStopChanges();
      } else {
        this.fObligationsPagination.page = 1;
      }
    },
    search: function() {
      if (this.currentPage === 1) {
        this.getFiscalObligationsIfStopChanges();
      } else {
        this.fObligationsPagination.page = 1;
      }
    },
    currentPage: function() {
      this.getFiscalObligationsIfStopChanges();
    },
    perPage: function() {
      if (this.currentPage === 1) {
        this.getFiscalObligationsIfStopChanges();
      } else {
        this.fObligationsPagination.page = 1;
      }
    },
    sortBy: function() {
      if (this.sortBy != null && this.sortTable) {
        this.getFiscalObligationList();
      } else {
        if (this.descending === null) {
          this.sortTable = false;
        }
      }
    },
    descending: function() {
      if (this.descending != null) {
        this.getFiscalObligationList();
        this.sortTable = true;
      } else {
        if (this.sortBy === null) {
          this.sortTable = false;
        }
      }
    },
    selectedConsultants: function() {
      if (this.currentPage === 1) {
        this.getFiscalObligationsIfStopChanges();
      } else {
        this.fObligationsPagination.page = 1;
      }
    },
    selectedLaborConsultants: function() {
      if (this.currentPage === 1) {
        this.getFiscalObligationsIfStopChanges();
      } else {
        this.fObligationsPagination.page = 1;
      }
    },
    selectedModelStatus: function() {
      if (this.currentPage === 1) {
        this.getFiscalObligationsIfStopChanges();
      } else {
        this.fObligationsPagination.page = 1;
      }
    },
    selectedModelType: function() {
      if (this.currentPage === 1) {
        this.getFiscalObligationsIfStopChanges();
      } else {
        this.fObligationsPagination.page = 1;
      }
    },
    hasEmployees: function() {
      if (this.currentPage === 1) {
        this.getFiscalObligationsIfStopChanges();
      } else {
        this.fObligationsPagination.page = 1;
      }
    },
    hasProfessionals: function() {
      if (this.currentPage === 1) {
        this.getFiscalObligationsIfStopChanges();
      } else {
        this.fObligationsPagination.page = 1;
      }
    },
  },
};
</script>

<style scoped>
.bg-lightgray {
  background-color: lightgray;
}
.bg-lightgreen {
  background-color: #00afa8;
}
.text-red {
  color: red;
}
.v-menu__activator {
  justify-content: center !important;
}
</style>
